import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import getColumns from "./column.js";
import DynamicTable from "../../../components/common/DynamicTable.jsx";
import useModal from "../../../hooks/useModal.js";
import useConfirm from "../../../hooks/useConfirm.js";
import { deletePayrollTemplate, getPayrollTemplates } from "../../../services/payrollTemplate.js";
import AddEditPayrollTemplate from "./AddEditPayrollTemplate.jsx";
import usePaginatedList from "../../../hooks/usePaginatedList.js";

const PayrollTemplateList = () => {
  const { confirm } = useConfirm();
  const { showModal } = useModal();

  const fetchData = async (params) => {
    return await getPayrollTemplates(params.page, params);
  };

  const { data, pagination, setPage, setItemsPerPage, refresh } = usePaginatedList(fetchData);

  const handleCreate = () => {
    showModal("Add Payroll Template", <AddEditPayrollTemplate refresh={refresh} />, "xl");
  };

  const handleEdit = (row) => {
    showModal("Edit Payroll Template", <AddEditPayrollTemplate refresh={refresh} existingField={row} />, "xl");
  };

  const handleDelete = async (id) => {
    try {
      const isConfirmed = await confirm({
        title: "Confirm Deletion",
        content: "Are you sure you want to delete this payroll template? Wage rates that already copied its components are unaffected.",
        confirmText: "Yes, Delete",
        cancelText: "Cancel",
      });
      if (!isConfirmed) return;

      await deletePayrollTemplate(id);
      toast.success("Payroll template deleted successfully!");
      refresh();
    } catch (error) {
      console.log("Error in deleting payroll template", error);
      toast.error(error?.response?.data?.message || "Error in deleting payroll template");
    }
  };

  return (
    <>
      <div className="bg-light mb-2">
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div className="d-flex align-items-center gap-2">
              <label className="mb-0 text-muted small">Show</label>
              <select
                className="form-select form-select-sm"
                style={{ width: "80px" }}
                value={pagination?.itemsPerPage || 20}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span className="text-muted small">entries</span>
            </div>

            <button className="btn btn-success btn-sm d-flex align-items-center" onClick={handleCreate}>
              <AddIcon sx={{ fontSize: 18 }} className="me-1" />
              <span className="d-none d-sm-inline">Add Payroll Template</span>
            </button>
          </div>

          <div className="form-text mt-2">
            A reusable Basic/HRA/DA/TA recipe you can pick from the Payroll Template dropdown on Add Wage Rate - selecting one copies
            its payheads onto that wage rate, editable afterward. Editing a template here never changes wage rates that already used it.
          </div>
        </div>
      </div>

      <DynamicTable
        columns={getColumns(handleEdit, handleDelete)}
        data={data}
        rowKey="id"
        currentPage={pagination?.currentPage}
        totalPages={pagination?.totalPages}
        itemsPerPage={pagination?.itemsPerPage}
        totalItems={pagination?.totalItems}
        onPageChange={(page) => setPage(page)}
      />
    </>
  );
};

export default PayrollTemplateList;
